import React from 'react';
import { useRoutes } from 'react-router-dom';
import { AutoScrollToTop } from '@src/components/auto-scroll-to-top';
import { globalConfig } from '../config';
import { RouterConfig } from './helper/history';
import { LazyElement, routerConfigManager } from './helper/factory';

export { goback } from './helper/navigate';

export * from '@src/routes/route';
export * from '@src/routes/helper/hooks';

/**
 * 推荐使用BrowserRouter路由模式， 也是目前路由支持的方式
 * - 如需通过一级路径区分多个项目部署， 请修改 package.json 中的 homepage 字段
 *
 * 目前路由不支持hash router， 如必须使用hash router，请自定义react Router V6 HashRouter
 */

const RouteConfig = () => {
  // 404 页面
  routerConfigManager.createRoute({
    path: '*',
    element: <LazyElement load={() => import('@src/page/not-found')} />,
  });
  const routesElement = useRoutes(routerConfigManager.getRoutesConfig());
  return <>{routesElement}</>;
};

export const RouteProvider = () => (
  <RouterConfig.Router basename={globalConfig.basename}>
    <AutoScrollToTop>
      <RouteConfig />
    </AutoScrollToTop>
  </RouterConfig.Router>
);
